var map = {
	"./graphic.vue": "4c8c",
	"./hello.vue": "28e8",
	"./loader/fbx.vue": "f290",
	"./loader/gltf.vue": "26cd",
	"./material.vue": "a06a",
	"./shader/texture.vue": "a0cb",
	"./shader/transfer.vue": "4a93",
	"./shader/triangle.vue": "2479",
	"./shader/uvanimate.vue": "f731",
	"./shader/vertexcolor.vue": "ad1d",
	"./t_cube.vue": "500c",
	"./temp.vue": "4895"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c321";